import React, { useEffect } from 'react';

const ExternalRedirect = ({ to, isPdf = false }) => {
  useEffect(() => {
    console.log('ExternalRedirect: Attempting to redirect to:', to);
    
    // Add cache-busting parameter
    const urlWithCacheBuster = `${to}?cb=${Date.now()}`;
    console.log('URL with cache buster:', urlWithCacheBuster);
    
    // Try multiple redirection methods
    const redirectMethods = [
      () => window.location.href = urlWithCacheBuster,
      () => window.location.replace(urlWithCacheBuster),
      () => window.open(urlWithCacheBuster, '_self'),
      () => window.open(urlWithCacheBuster, '_blank')
    ];

    let methodIndex = 0;
    
    const tryRedirect = () => {
      if (methodIndex < redirectMethods.length) {
        try {
          console.log(`Trying redirect method ${methodIndex + 1}`);
          redirectMethods[methodIndex]();
          methodIndex++;
        } catch (error) {
          console.error(`Redirect method ${methodIndex + 1} failed:`, error);
          methodIndex++;
          setTimeout(tryRedirect, 100);
        }
      }
    };

    // Start trying redirects after a short delay
    setTimeout(tryRedirect, 200);
  }, [to, isPdf]);

  return (
    <div style={{ 
      padding: '50px 20px', 
      textAlign: 'center',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h2>Redirigiendo...</h2>
      <p>Estás siendo redirigido a: <strong>{to}</strong></p>
      <p>Si no eres redirigido automáticamente en unos segundos, haz clic en el enlace de abajo:</p>
      <a 
        href={`${to}?cb=${Date.now()}`}
        target="_blank" 
        rel="noopener noreferrer"
        style={{
          display: 'inline-block',
          padding: '12px 24px',
          backgroundColor: '#007bff',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '5px',
          marginTop: '20px',
          fontSize: '16px'
        }}
      >
        Continuar a {to.replace('https://', '')}
      </a>
    </div>
  );
};

export default ExternalRedirect; 